import { PropsWithChildren } from "react";
import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { createLoadLocalizationKeysAction, DEFAULT_FETCHING_KEY, hasLocalization } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { LocalizationLoaderComponent, LocalizationLoaderComponentProps } from "./LocalizationLoaderComponent";

export type LocalizationMultiLoaderProps = PropsWithChildren<Readonly<{
    /** Pole lokalizačních klíčů pro načtení */
    locKeys: readonly string[];
    /**
     * Klíč pro fetching modul, pod kterým bude indikováno načítání.
     * Pokud není zadaný, použije se výchozí hodnota sdílená pro všechny LocalizationLoader a LocalizationMultiLoader komponenty.
     */
    fetchingKey?: string;
}>>;

type StateProps = Pick<LocalizationLoaderComponentProps, "localizationsLoaded">;
type DispatchProps = Pick<LocalizationLoaderComponentProps, "loadLocalizations">;

const mapStateToProps: MapStateToProps<StateProps, LocalizationMultiLoaderProps, IAppState> = (state, { locKeys }) => ({
    localizationsLoaded: !locKeys.some((locKey) => !hasLocalization(state, locKey)),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, LocalizationMultiLoaderProps> = (dispatch, { locKeys, fetchingKey = DEFAULT_FETCHING_KEY }) => ({
    loadLocalizations: () => dispatch(createLoadLocalizationKeysAction(locKeys, fetchingKey, true)),
});

/**
 * Zajišťuje načtení lokalizačních klíčů, pokud alespoň jeden z nich ještě není načtený. Slouží pro případ více klíčů, pro načítání jednoho klíče je možné
 * použít {@link LocalizationLoader}.
 */
export const LocalizationMultiLoader = connect(mapStateToProps, mapDispatchToProps)(LocalizationLoaderComponent);
